import { DebouncedTextInput } from "ra-friendsofbabba";
import React from "react";
import { required } from "ra-core";
import { useFormState } from "react-final-form";

const ForeignOfficeInput = (props) => {
  const formState = useFormState();
  const foreignMonths = formState.values.foreign_months || 0;
  if (foreignMonths === 0) {
    return null;
  }
  return <DebouncedTextInput {...props} validate={required()} />;
};
export default ForeignOfficeInput;
